import { useEffect } from 'react';
import BrowserStorageAccessor from 'common/utils/BrowserStorageAccessor.js';
import { v4 as uuid } from 'uuid';
import { isTeamLicense } from 'common/utils/utils.js';
import {
  LOCAL_STORAGE_KEYS,
  SESSION_STORAGE_KEYS,
  LICENSE_PLAN_IDS
} from 'common/constants/constants';
import { LICENSE_PLAN_TIER_TYPE } from '@linearb/linjs-common';
import { CenterLoader } from 'connected-components/Loader/Loader';

const AddOrganization = ({ account, createOrganization }) => {
  const addOrganization = async () => {
    const browserStorageAccessor = BrowserStorageAccessor();
    const hid = browserStorageAccessor.session.get(
      SESSION_STORAGE_KEYS.HUBSPOT_ID
    );
    const license =
      browserStorageAccessor.local.get(LOCAL_STORAGE_KEYS.LICENSE) || 'team';

    const organizationData = {
      name: uuid(),
      type_id: 1,
      tier_type: license,
      ...(hid ? { hid } : {}),
      ...(license === LICENSE_PLAN_TIER_TYPE.ESSENTIAL
        ? { plan_id: LICENSE_PLAN_IDS.ESSENTIAL_TRIAL }
        : {})
    };

    await createOrganization(organizationData, account);

    if (isTeamLicense()) {
      browserStorageAccessor.local.set(
        LOCAL_STORAGE_KEYS.SHOW_IS_THAT_YOUR_TEAM_BAR,
        new Date()
      );
    }
  };

  useEffect(() => {
    (async () => {
      if (account && !account.organization_id) {
        await addOrganization();
      }
    })();
  }, [account]);

  return <CenterLoader />;
};

export default AddOrganization;
